import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ModulePage from "./ModulePage";

const TASKS_SEGMENT = "/tasks";

function RoutedModulePage(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const taskType = location.state?.taskType || null;
  const anchorQuestionId = new URLSearchParams(location.search).get("q")?.trim() || null;
  const tasksIndex = location.pathname.lastIndexOf(TASKS_SEGMENT);
  const taskSelectionPath =
    tasksIndex >= 0
      ? location.pathname.slice(0, tasksIndex + TASKS_SEGMENT.length)
      : `${location.pathname.replace(/\/$/, "")}${TASKS_SEGMENT}`;

  return (
    <ModulePage
      {...props}
      taskType={taskType}
      anchorQuestionId={anchorQuestionId}
      onTaskTypeSelect={(type) => navigate(taskSelectionPath, { state: { taskType: type } })}
      onBackToTaskTypes={() => navigate(taskSelectionPath)}
    />
  );
}

export default RoutedModulePage;
